import apiPengajuanStokis from '@/api/vo-general/pengajuanStokis'

const defaultState = () => ({
  
});

const state = defaultState()

const getters = {
};

const mutations = {
	
};

const actions = {
	addStockist({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPengajuanStokis.addStockist(params).then((results) => {
				const data = results.data
				dispatch('success', data, { root : true });
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};